// extracted by mini-css-extract-plugin
export default {"loader":"SpinnerButton_loader__IMeZe","relative":"SpinnerButton_relative__2ZawY","hideText":"SpinnerButton_hideText__GDWKR"};